<template lang="pug">
  .mt-map(:id='id')
    slot(v-if='ready')
</template>

<script>
import { createMap } from '@/utils/mapService'
import { MAP_ANIMATE_INTERVAL } from '@/app.config'
import eventTunnel from '@/utils/eventTunnel'

const events = [
  'zoomend'
]

export default {
  props: {
    id: {
      type: String,
      default: 'map'
    },
    options: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      mapObject: null,
      ready: false
    }
  },
  async mounted () {
    const map = await createMap({
      id: this.id,
      options: this.options
    })

    events.forEach(event => {
      map.on(event, ev => {
        this.$emit(`mt-${event}`, ev)
      })
    })

    this.mapObject = map
    this.ready = true
  },
  created () {
    eventTunnel.$on('map_animateTo', ({ center, cb }) => {
      this.mapObject.animateTo({
        center
      }, {
        duration: MAP_ANIMATE_INTERVAL
      }, ({ state: { playState } }) => {
        if (playState === 'finished' &&
          typeof cb === 'function') {
          cb()
        }
      })
    })
  },
  beforeDestroy () {
    this.mapObject.remove()
  }
}
</script>

<style scoped>
.mt-map {
  width: 100%;
  height: 100%;
}
</style>
